var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{btn: true, alternate: _vm.isAlt}},[_c('div',{staticClass:"trigger"},[_c('a',{attrs:{"href":_vm.href,"target":"_blank","data-closer":_vm.data_closer}},[_vm._t("default")],2),_vm._v(" "),_c('div',{class:{bg: true, alternate: _vm.isAlt}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76b7b186","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Button.vue
// module id = null
// module chunks = 